/*jshint strict: false */
(
    function (window, document, $, _, undefined) {
        function updateRoles() {
            var roleSelect = $('#role'),
                countrySelect = $('#country'),
                industrySelect = $('#industry'),
                selectedCountry = countrySelect.val(),
                selectedIndustry = industrySelect.val(),
                selectedMarketId,
                selectedCountryId;

            if (_.isEmpty(selectedCountry) && _.isEmpty(selectedIndustry)) {
                roleSelect.attr('disabled', 'disabled')
                    .attr('aria-disabled', 'true')
                    .prop('disabled', true);
            } else {
                roleSelect.removeAttr('disabled')
                    .attr('aria-disabled', 'false')
                    .prop('disabled', false);

                roleSelect.find('option[value!=""]').detach();

                if (!_.isEmpty(selectedCountry) && !_.isEmpty(selectedIndustry)) {
                    selectedCountryId = countrySelect.find('option:selected').data('id');
                    selectedMarketId = industrySelect.find('option:selected').data('market-id');

                    window.roleOptions.each(
                        function () {
                            var opt = $(this);

                            if (opt.data('market') === selectedMarketId && opt.data('country') === selectedCountryId) {
                                roleSelect.append(opt);
                            }
                        }
                    );
                }
            }
        }

        $(document).ready(
            function () {
                var roleSelect = $('#role'),
                countrySelect = $('#country'),
                industrySelect = $('#industry');

                window.roleOptions = roleSelect.find('option[value!=""]').detach();

                updateRoles();

                countrySelect.on(
                    'change.one-health',
                    updateRoles
                );
                industrySelect.on(
                    'change.one-health',
                    updateRoles
                );
            }
        );
    }
)(window, document, window.jQuery, window._);
